import { QueryConfig, QueryResult, useQuery } from "react-query";
import { promotionsService } from "../services/promotions";

const USE_CHECK_NAME = "USE_CHECK_NAME";

export const useCheckPromotionName = (
    promotionName: string,
    merchantId: string,
    options?: QueryConfig<boolean>,
): QueryResult<boolean, string> => {
    return useQuery<boolean, string>(
        [USE_CHECK_NAME, promotionName, merchantId],
        () => promotionsService.isPromotionNameExist(promotionName, merchantId),
        options,
    );
};
